import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';

const Documents = ({ ...props }) => {
  Documents.propTypes = {
    row: PropTypes.number,
    opportunity: PropTypes.object,
    referral: PropTypes.object,
    property: PropTypes.object,
    documents: PropTypes.array,
    userprofile: PropTypes.object,
    showDocumentModal: PropTypes.func.isRequired,
    showDocInModal: PropTypes.bool.isRequired,
    additionalDocuments: PropTypes.array,
    markOpportunityDocumentRead: PropTypes.func.isRequired
  };

  function checkImageOrText(url) {
    const allowedExtensions = ['.gif', '.txt', '.jpeg', '.jpg', '.png'];
    for (let extension of allowedExtensions) {
      if (url.toLowerCase().endsWith(extension)) {
        return true;
      }
    }
    return false;
  }

  const leadSource = _.get(props, 'referral.leadSources[0].leadSource', '');
  const oppAddDocs = (props.additionalDocuments || []).filter(ad => _.get(ad, 'opportunityId', undefined) === _.get(props, 'opportunity.opportunityKey', null));
  return (
    <React.Fragment>
      <div>
        <div className='d-flex justify-content-between'>
          <small>
            DOCUMENT NAME
          </small>
          <small>
            UPLOAD DATE
          </small>
        </div>
        {
          props.documents && props.documents.length > 0 && props.documents
            .map((documentDetails, index) => {
              return (
                <div className='d-flex justify-content-between' key={`document${index}`}>
                  <div className='text-truncate'>
                    {
                      (checkImageOrText(documentDetails.documentURL))? (
                        <a onClick={() => {
                          props.showDocumentModal(documentDetails.documentURL, leadSource);
                        }}>
                          {`${documentDetails.documentName.substr(0, 19)}${(documentDetails.documentName.length > 20) ? '...' : ''}`}
                        </a>
                      ) : (
                        <a href={documentDetails.documentURL} download>
                          {`${documentDetails.documentName.substr(0, 19)}${(documentDetails.documentName.length > 20) ? '...' : ''}`}
                        </a>
                      )
                    }
                  </div>
                  {
                  documentDetails.uploadDate && <div>
                      {moment(documentDetails.uploadDate).utc(false).format('M/D/YY')}
                    </div>
                  }
                </div>
              );
            })
        }
        {
          oppAddDocs && oppAddDocs.length > 0 &&
            oppAddDocs.map((documentMapping, index) => {
              const documentName = _.get(documentMapping, 'documentAlias', _.get(documentMapping, 'document.name', 'Document'));
              return <div className='d-flex justify-content-between text-truncate' key={`document${index}`}>
                {
                  props.showDocInModal ? <a onClick={() => {
                    props.markOpportunityDocumentRead(documentMapping);
                    props.showDocumentModal(documentMapping.documentURL, leadSource);
                  }}>
                    {`${documentName}`} 
                  </a>
                    : <a onClick={() => {
                      props.markOpportunityDocumentRead(documentMapping);
                    }} href={documentMapping.documentURL} download>
                      {`${documentName}`}
                    </a>
                }
              </div>;
            })
        }
      </div>
    </React.Fragment>
  );
};
export default Documents;
